import { Plugins } from '@leverege/plugin';
import { UserSettings } from '@leverege/ui-redux';
import { RolloverModel, SelectionModel } from '@leverege/ui-attributes';
import P from '@leverege/promise';
import I18N from '@leverege/i18n';
import { LinkAction } from "../routes/index.js";
import SettingsModelScreen from "../screens/settings/SettingsModelScreen.js";
const {
  t,
  tIcon
} = I18N.ns('molten.attributes.DetailsInitializer');
const DEFAULT_DETAIL_TYPES = [{
  model: RolloverModel,
  settingsPath: 'rolloverModel',
  routePath: '/settings/rollover',
  icon: 'fa fa-mouse-pointer fa-fw'
}, {
  model: SelectionModel,
  settingsPath: 'selectionModel',
  routePath: '/settings/selection',
  icon: 'fa fa-dot-circle-o fa-fw'
}];

/**
 * This will create the default detail modesl for rollover and selection
 * and install settings options for them
 */
async function onLoggedIn(molten) {
  const detailTypes = DEFAULT_DETAIL_TYPES;
  if (Array.isArray(detailTypes)) {
    await P.map(detailTypes, async typeConfig => {
      return installTypesFromConfig(molten, typeConfig);
    });

    // Keep this synchronous so that order in the tree is respected
    detailTypes.forEach(typeConfig => installPluginsFromConfig(molten, typeConfig));
  }
}
async function installFor(molten, name, model) {
  UserSettings.addDefault(name, model.create);
  UserSettings.addIntercept(name, originalMdl => {
    const dataSources = Plugins.get('DataSource');
    let mdl = originalMdl;
    for (let n = 0; n < dataSources.length; n++) {
      const ds = dataSources[n];
      if (model.getType(mdl, ds.type) == null) {
        mdl = model.addType(mdl, ds.type);
      }
    }
    return mdl;
  });
  const store = molten.get('store');
  const state = store.getState();
  await UserSettings.get(state, name);
}
function installTypesFromConfig(molten, config) {
  const {
    model,
    settingsPath
  } = config;
  return installFor(molten, settingsPath, model);
}
function installPluginsFromConfig(molten, config) {
  const {
    settingsPath,
    versionsPath = settingsPath,
    settingsTitle,
    actionLinkName,
    icon,
    routePath
  } = config;
  addSettingsAction(molten, settingsPath, {
    name: t(`${settingsPath}Action`, actionLinkName),
    icon: tIcon(`${settingsPath}Icon`, icon),
    path: routePath
  });
  addSettingsRoute(molten, settingsPath, {
    name: t(`${settingsPath}Settings`, settingsTitle),
    icon: tIcon(`${settingsPath}Icon`, icon),
    path: routePath,
    settingsPath,
    versionsPath
  });
}
function addSettingsAction(molten, idName, {
  name,
  icon,
  path
}) {
  molten.addPlugin('Action', LinkAction.create({
    id: `settings.action.${idName}`,
    matches: {
      use: 'navBar',
      client: 'SettingsScreen'
    },
    name,
    icon,
    path
  }));
}
function addSettingsRoute(molten, idName, {
  name,
  icon,
  path,
  settingsPath,
  versionsPath
}) {
  molten.addPlugin('Route', {
    id: `settings.route.${idName}`,
    exact: true,
    path,
    matches: {
      client: 'SettingsScreen'
    },
    component: SettingsModelScreen,
    props: {
      settingsPath,
      versionsPath,
      name,
      icon
    }
  });
}
export default {
  type: 'molten.DetailsInitializer',
  onLoggedIn,
  sort: 10
};